import React, { Component } from "react";
    import Card from "../../../components/common/Card";
    import CardHeader from "../../../components/common/CardHeader";
    import CardBody from "../../../components/common/CardBody";
    import CardTitle from "../../../components/common/CardTitle";
    import {
    Table,
    TableHead,
    TableRow,
    TableBody,
    TableCell
    } from "@mui/material";
    import Modal from "react-bootstrap/Modal";
    import Button from "react-bootstrap/Button";
    import Spinner from "react-bootstrap/Spinner";
    import PageSpinner from "../../../components/common/spinner/PageSpinner";
    import "../../../components/admin/css/common.css";
    import sweetAlert, {
    sweetConfirmAlert,
    sweetStatusAlert,
    sweetAlertInfo,
    } from "../../../components/common/SweetAlert";
    import SimpleReactValidator from "simple-react-validator";
    import Col from "react-bootstrap/Col";
    import Form from "react-bootstrap/Form";
    import Row from "react-bootstrap/Row";
    import { TypeService } from "../../../service/manage/subscription/type.service";
    import { AssessmentCreditPackService } from "../../../service/manage/exam_subscription/assessCreditPackage.service.js";
    import { currencyTypeService } from "../../../service/settings/manage/currency_type.service.js";
    import config from "../../../helper/config";
    import { customerConstants } from "../../../helper/constants.js";
    import moment from "moment-timezone";
    import CheckBoxInline from "../../../components/common/form/CheckBoxInline.js";
    import CheckBox from "../../../components/common/form/CheckBox.js";
import { parse } from "@fortawesome/fontawesome-svg-core";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";


    const getCustomerFeatureFlag = () => {
    return config.customerConfigs.featureFlag;
    };

    let addBtnStyle, closeBtnStyle;
    const customer = getCustomerFeatureFlag();
    switch (customer) {
    case customerConstants.EXO_CUSTOMER1:
        break;
    case customerConstants.EXO_CUSTOMER2:
        closeBtnStyle = {
        color: "var(--maincolor-cmc)",
        backgroundColor: "#E5F5FF",
        borderColor: "transparent",
        };
        addBtnStyle = {
        color: "#fff",
        backgroundColor: "var(--maincolor-cmc)",
        borderColor: "transparent",
        };
        break;
    default:
        break;
    }

    export default class AssessCreditPackages extends Component {
    constructor(props) {
        super(props);
        this.state = {
        showInsertModal: false,
        showModal: false,
        isLoading: false,
        isTableDataLoading: true,
        isModified: false,
        selectedStudentId: "",
        selectedStudentTable: "",
        expiryType: 'days',
        expiryDays: '',
        expiryDate: '',
        selectedStudent: null,
        search_id: "",
        isStudentsLoading: false,
        isSubmitting: false,
        registration_id: "",
        editVisibility: false,
        addVisibility: false,
        breadcrumb2: null,
        nodeTitle: null,
        flg_list_active: null,
        types: "",
        type_id: "",
        name: "",
        description: "",
        initialDescription: "",
        credits: "",
        discount_rate: "",
        userType: "",
        typesPrivilege: null,
        isFreeCredits: false,
        discountRateError: "",
        status: "",
        start_date: "",
        end_date: "2099-12-31 00:00:00",
        statuses: [
            {
            id: "Active",
            name: "Active",
            },
            {
            id: "Deactive",
            name: "Deactive",
            },
        ],
        form_list_id: "",
        noEndDate: true,
        packageType: 'regular', // default value
        description: '',
        allCurrencyTypes: [],
        currency_type_id: '',
        minimum_package_amount: '',
        };

        this.createValidationsInstance();
    }

    handleTabChange = (event, newValue) => {
        this.setState({ activeTab: newValue });
    };

    // Reset all form fields and validation messages
    resetFormAndValidation = () => {
        this.setState({
            name: "",
            credits: "",
            discount_rate: "",
            description: "",
            packageType: "regular",
            status: "",
            start_date: "",
            end_date: "",
            currency_type_id: "",
            minimum_package_amount: "",
            expiryType: "days",
            expiryDays: "",
            expiryDate: "",
            noEndDate: true,
            discountRateError: "",
            creditsError: "",
            isModified: false,
        }, () => {
            if (this.validator) {
                this.validator.purgeFields();
                this.validator.hideMessages();
                this.forceUpdate();
            }
        });
    }

    createValidationsInstance() {
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this, // This enables automatic re-rendering when validations change
            validators: {
                isFloat: {
                    message: "The :attribute must be a valid number.",
                    rule: (val) => {
                        return /^[+-]?\d+(\.\d+)?$/.test(val);
                    }
                },
                isDecimal: {
                    message: "Value must be a valid decimal number with up to 2 decimal places.",
                    rule: (val) => {
                        return /^\d+(\.\d{1,2})?$/.test(val);
                    }
                },
                dateAfter: {
                    message: "The :attribute must be after :date.",
                    rule: (val, params) => {
                        if (!val) return false;
                        
                        const comparisonDate = params[0] === 'start_date' 
                            ? this.state.start_date 
                            : params[0];
                        
                        if (!comparisonDate) return true;
                        
                        const minDate = new Date(comparisonDate);
                        const selectedDate = new Date(val);
                        return selectedDate > minDate;
                    },
                    messageReplace: (message, params) => {
                        return message.replace(':date', params[0] === 'start_date' 
                            ? 'the package start date' 
                            : 'package start date');
                    }
                },
                maxDays: {
                    message: "Cannot be more than :max days.",
                    rule: (val, params) => {
                        const num = parseInt(val, 10);
                        return !isNaN(num) && num >= 1 && num <= params[0];
                    },
                    messageReplace: (message, params) => message.replace(':max', params[0])
                }
            },
            messages: {
                required: "The :attribute field is required.",
                min: "The :attribute must be at least :min.",
                max: "The :attribute must be less than :max."
            }
        });
    }

    componentDidMount() {
        const {
        privilege_add,
        privilege_edit,
        breadcrumb2,
        nodeTitle,
        flg_list_active,
        form_list_id,
        } = this.props.props;
        this.getVisibilityCheck(privilege_add, privilege_edit);
        this.getAllTypes();
        this.getAllCurrencyTypes();
        this.setState({
        breadcrumb2: breadcrumb2,
        nodeTitle,
        flg_list_active,
        userType: sessionStorage.getItem("userType"),
        typesPrivilege: this.props.typesPrivilege,
        form_list_id: form_list_id,
        });
    }

    getAllTypes() {
        const mid = 100;
        AssessmentCreditPackService.getAllPackages(mid)
        .then((res) => {
            if (res.success) {
            this.setState({ types: res.data.creditPackages });
            } else {
            sweetStatusAlert(
                "Failed!",
                "Error fetching credit packages. Please refresh the screen!",
                "error"
            );
            }
        })
        .finally(() => {
            this.setState({
            isTableDataLoading: false,
            });
        });
    }

    getAllCurrencyTypes() {
        currencyTypeService.getAllCurrencyTypes()
        .then((res) => {
            if (res.success) {
                this.setState({ allCurrencyTypes: res.data.currency_types });
            } else {
                sweetStatusAlert(
                    "Failed!",
                    "Error fetching currency types. Please refresh the screen!",
                    "error"
                );
            }
        })
        .catch(() => {
            sweetStatusAlert(
                "Failed!",
                "Error fetching currency types. Please refresh the screen!",
                "error"
            );
        });
    }

    getVisibilityCheck(privilege_add, privilege_edit) {
        if (privilege_add == "1") {
        this.setState({
            addVisibility: true,
        });
        }
        if (privilege_edit == "1") {
        this.setState({
            editVisibility: true,
        });
        }
    }

    submitType = () => {
        const { packageType, currency_type_id, minimum_package_amount } = this.state;
        
        // Check if minimum package amount fields are valid for regular packages
        const minPackageValidation = packageType === 'regular' ? 
            this.validator.fieldValid("currency_type_id") && this.validator.fieldValid("minimum_package_amount") : 
            true;

        if (this.validator.allValid() &&
            this.validator.fieldValid("credits") &&
            this.validator.fieldValid("discount_rate") &&
            minPackageValidation
        ) {
            this.setState({ showInsertModal: false, isLoading: true });
            const mid = 100;
            const session_id = sessionStorage.getItem("manage_user_id");
            const table_log_id = sessionStorage.getItem("table_log_id");
    
            const {
                name,
                credits,
                discount_rate,
                description,
                status,
                start_date,
                end_date,
                form_list_id,
                packageType,
                expiryType,
                expiryDays,
                expiryDate,
                currency_type_id,
                minimum_package_amount,
            } = this.state;
    
            let obj = {
                node_mid: mid,
                name: name,
                credits: parseInt(credits),
                discount_rate: discount_rate,
                description: description,
                package_type: packageType, 
                user_id: session_id,
                user_table_id: table_log_id,
                create_user_id: session_id,
                create_user_table_id: table_log_id,
                status: status,
                start_date: start_date,
                end_date: end_date ? end_date : "2099-12-31 00:00:00",
                form_list_id: form_list_id,
                credits_expiry_type: expiryType,
                credits_expiry_duration: expiryType === 'days' ? expiryDays : expiryDate,
            };

            // Add minimum_package_amount only for regular packages
            if (packageType === 'regular' && currency_type_id && minimum_package_amount) {
                obj.currency_type_id = currency_type_id;
                obj.minimum_package_amount = minimum_package_amount;
            }
            AssessmentCreditPackService.createCreditPackage(JSON.stringify(obj))
            .then((res) => {
            if (res.success) {
                this.setState({ showInsertModal: false });
                this.getAllTypes();
                sweetStatusAlert("Success!", res.message.success, "success");
            } else {
                sweetStatusAlert("Failed!", res.message || res.message.error , "error");
            }
            })
            .catch(() => {
            sweetStatusAlert(
                "Failed !",
                "Unable to add the credit packages!",
                "error"
            );
            })
            .finally(() => {
            this.resetFormAndValidation();
            // Hide loading indicator
            this.setState({ isLoading: false });
            });
        }else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };

    updateType = () => {
        const { packageType, currency_type_id, minimum_package_amount } = this.state;
        
        // Check if minimum package amount fields are valid for regular packages
        const minPackageValidation = packageType === 'regular' ? 
            this.validator.fieldValid("currency_type_id") && this.validator.fieldValid("minimum_package_amount") : 
            true;

        if (
        this.validator.allValid() &&
        this.validator.fieldValid("credits") &&
        this.validator.fieldValid("discount_rate") &&
        minPackageValidation
        ) {
        this.setState({ showModal: false, isLoading: true });
        const {
            name,
            credits,
            discount_rate,
            description,
            type_id,
            status,
            start_date,
            end_date,
            form_list_id,
            packageType,
            expiryType,
            expiryDays,
            expiryDate,
            currency_type_id,
            minimum_package_amount,
        } = this.state;
        const mid = 100;
        const session_id = sessionStorage.getItem("manage_user_id");
        const table_log_id = sessionStorage.getItem("table_log_id");

        let obj = {
            node_mid: mid,
            name: name,
            credits: credits,
            discount_rate: discount_rate,
            description: description,
            package_type: packageType, 
            user_id: session_id,
            user_table_id: table_log_id,
            status: status,
            start_date: start_date,
            end_date: end_date ? end_date : "2099-12-31 00:00:00",
            form_list_id: form_list_id,
            credits_expiry_type: expiryType,
            credits_expiry_duration: expiryType === 'days' ? expiryDays : expiryDate,
        };

        // Add minimum_package_amount only for regular packages
        if (packageType === 'regular' && currency_type_id && minimum_package_amount) {
            obj.currency_type_id = currency_type_id;
            obj.minimum_package_amount = minimum_package_amount;
        }
        AssessmentCreditPackService.updateCreditPackage(JSON.stringify(obj), type_id)
            .then((res) => {
            if (res.success) {
                this.setState({ showModal: false });
                this.getAllTypes();
                sweetStatusAlert("Success!", res.message.success, "success");
            } else {
                sweetStatusAlert("Failed!", res.message || res.message.error , "error");
            }
            })
            .catch(() => {
            sweetStatusAlert("Failed !", "Unable to update the credit package!", "error");
            })
            .finally(() => {
            this.resetFormAndValidation();
            this.setState({ isLoading: false });
            });
        } else {
        this.validator.showMessages();
        this.forceUpdate();
        }
    };

    deleteType = (type_id) => {
        sweetConfirmAlert(
        "Are you sure?",
        "Do you want to delete this Credit Package?",
        "warning"
        ).then(() => {
        this.setState({ isLoading: true });
        AssessmentCreditPackService.deleteCreditPackage(type_id, this.state.form_list_id)
            .then((res) => {
            if (res.status === 200) {
                this.setState({ showModal: false });
                this.getAllTypes();
                sweetStatusAlert("Success!", res.message.success, "success");
            } else if(res.status === 400){
                sweetAlertInfo(
                "",
                "Cannot delete credit package. This credit package already in use.",
                );
            }else{
                sweetStatusAlert("Failed!", res.message || res.message.error, "error");
            }
            })
            .catch(() => {
            sweetStatusAlert(
                "Failed !",
                "Unable to delete the credit package!",
                "error"
            );
            })
            .finally(() => {
            this.setState({ isLoading: false });
            });
        });
    };

    handleSweetAlert = (toggleFunction, modalVisibility) => {
        if (this.state.isModified) {
        sweetAlert().then((response) => {
            this.validator.purgeFields();
            this.validator.hideMessages();
            this.setState(() => ({
            [modalVisibility]: response,
            isModified: false,
            }));
        });
        } else {
        this.validator.purgeFields();
        this.validator.hideMessages();
        toggleFunction();
        }
    };

    handleChange = (event) => {
        const { name, value } = event.target;
        let error = this.state.discountRateError;
        let creditsError = "";

        if (name === "discount_rate") {
            const discountValue = parseFloat(value);
            if (discountValue < 0 || discountValue > 100) {
                error = "Discount rate must be between 0 and 100.";
            } else {
                error = "";
            }
        }

        if (name === "credits") {
            if (parseFloat(value) < 0) {
                creditsError = "Credits cannot be negative.";
            } else {
                creditsError = "";
            }
        }

        this.setState((prevState) => ({
            [name]: value,
            isModified: true,
            discountRateError: name === "discount_rate" ? error : prevState.discountRateError,
            creditsError: name === "credits" ? creditsError : prevState.creditsError,
        }));

        if (name === "start_date") {
            const endDateInput = document.querySelector('[name="end_date"]');
            if (endDateInput) {
                endDateInput.min = value;
            }
            this.setState({ [name]: value }, () => {
                if (name === 'start_date') {
                    if (this.state.expiryType === 'date' && this.state.expiryDate) {
                        if (this.state.expiryDate && new Date(this.state.expiryDate) <= new Date(this.state.start_date)) {
                            this.validator.showMessageFor('expiryDate');
                            this.setState({
                                expiryDateError: 'Expiry date must be after the start date'
                            });
                        } else {
                            this.setState({
                                expiryDateError: ''
                            });
                            this.validator.showMessageFor('expiryDate');
                        }
                    }
                }
            });
        }
    };

    toggleAddPackagelModal = () => {
        this.setState((prevState) => ({
            showInsertModal: !prevState.showInsertModal
        }), () => {
            if (!this.state.showInsertModal) {
                // Modal closed, reset fields and validation
                this.resetFormAndValidation();
            } else {
                // Modal opened, also clear validation
                if (this.validator) {
                    this.validator.purgeFields();
                    this.validator.hideMessages();
                    this.forceUpdate();
                }
            }
        });
    };

    handleRadioChangeAdd = (event) => {
        const value = event.target.value;
        this.setState({
            packageType: value
        });
    };

    handleRadioChangeUpdate = (event) => {
        const value = event.target.value;
        this.setState({
            packageType: value
        });
    };

    toggleUpdateTypeModal = (type) => {
        if (!this.state.showModal) {
            // Opening modal set fields and clear validation
            this.setState({
                showModal: true,
                type_id: type.credit_package_id,
                name: type.name || "",
                credits: type.credits || "",
                discount_rate: type.discount_rate || "",
                description: type.description || "",
                packageType: type.package_type || "regular",
                status: type.status || "",
                start_date: type.start_date || "",
                end_date: type.end_date || "",
                currency_type_id: type.currency_type_id || "",
                minimum_package_amount: (type.minimum_package_amount !== undefined && type.minimum_package_amount !== null) ? String(type.minimum_package_amount) : "",
                expiryType: type.credits_expiry_type || "days",
                expiryDays: type.credits_expiry_type === 'days' ? (type.credits_expiry_duration || "") : "",
                expiryDate: type.credits_expiry_type === 'date' ? (type.credits_expiry_duration || "") : "",
                noEndDate: !!type.end_date,
                discountRateError: "",
                creditsError: "",
                isModified: false,
            }, () => {
                if (this.validator) {
                    this.validator.purgeFields();
                    this.validator.hideMessages();
                    this.forceUpdate();
                }
            });
        } else {
            // Closing modal: reset fields and validation
            this.setState({ showModal: false }, () => {
                this.resetFormAndValidation();
            });
        }
    };

    handleExpiryTypeChange = (e) => {
    this.setState({ 
        expiryType: e.target.value,
        expiryDays: e.target.value === 'date' ? '' : this.state.expiryDays,
        expiryDate: e.target.value === 'days' ? '' : this.state.expiryDate
        });
    };

    handleExpiryDaysChange = (e) => {
        this.setState({ expiryDays: e.target.value });
    };

    handleExpiryDateChange = (e) => {
    this.setState({ expiryDate: e.target.value }, () => {
        if (this.validator) {
            this.validator.showMessageFor('expiryDate');
        }
        });
    };

    convertTimeLevel(utcDateString) {
        const userTimeZone = moment.tz.guess();
        const convertedDate = moment(utcDateString).tz(userTimeZone);
        const formattedDate = convertedDate.format("MMMM D, YYYY h:mm:ss a");
        return formattedDate;
    }

    formatDateForInput = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    noEndDateSelected = (e, status) => {
        if (status) {
        this.setState({ noEndDate: status, end_date: "" });
        } else {
        this.setState({ noEndDate: status, end_date: "2099-12-31 00:00:00" });
        }
    };

    render() {
        const {
        isLoading,
        isTableDataLoading,
        breadcrumb2,
        nodeTitle,
        addVisibility,
        editVisibility,
        type_id,
        name,
        description,
        credits,
        discount_rate,
        types,
        isFreeCredits,
        userType,
        typesPrivilege,
        status,
        start_date,
        end_date,
        statuses,
        discountRateError,
        noEndDate,
        } = this.state;
        this.validator.purgeFields();
        if (!typesPrivilege) {
        return (
            <div>
            <h4>Privilege not found for this section</h4>
            </div>
        );
        }
        return (
        <>
            <Card>
            <CardHeader>
                <div>
                <CardTitle cardLabel={"Assessment Credit Packages"} />
                </div>

                <div style={{ display: "flex", alignItems: "center" }}>
                    <Button
                    className="insert-btn"
                    variant="primary"
                    onClick={this.toggleAddPackagelModal}
                    >
                    Add Credit Package
                    </Button>
                </div>
            </CardHeader>
            <CardBody>
                {isLoading && (
                <PageSpinner id="show" text="Loading, Please wait!" />
                )}
                {isTableDataLoading ? (
                <div className="loading-container">
                    <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                    </Spinner>
                </div>
                ) : (
                <div className="manage-table-wrapper" style={{ height: "65vh" }}>
                    <Table>
                    <TableHead>
                        <TableRow>
                        <TableCell
                            className="thead"
                            style={{ textAlign: "center" }}
                        >
                            Credit Package Id
                        </TableCell>
                        <TableCell
                            className="thead"
                            style={{ textAlign: "center" }}
                        >
                            Name
                        </TableCell>
                        <TableCell
                            className="thead"
                            style={{ textAlign: "center" }}
                        >
                            Credits
                        </TableCell>
                        <TableCell
                            className="thead"
                            style={{ textAlign: "center" }}
                        >
                            Discount Rate
                        </TableCell>
                        <TableCell
                            className="thead"
                            style={{ textAlign: "center" }}
                        >
                            Description
                        </TableCell>
                        <TableCell
                            className="thead"
                            style={{ textAlign: "center" }}
                        >
                            Status
                        </TableCell>
                        <TableCell
                            className="thead"
                            style={{ textAlign: "center" }}
                        >
                            Start Date
                        </TableCell>
                        <TableCell
                            className="thead"
                            style={{ textAlign: "center" }}
                        >
                            End Date
                        </TableCell>
                        <TableCell
                            className="thead"
                            style={{ textAlign: "center" }}
                        >
                            Credit Expiry
                        </TableCell>
                            <TableCell
                            className="thead"
                            style={{ textAlign: "center" }}
                            >
                            Actions
                            </TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {!(types.length > 0) && (
                        <TableRow>
                            <TableCell colSpan={9} style={{ textAlign: "center" }}>
                            No data available
                            </TableCell>
                        </TableRow>
                        )}
                        {types.length > 0 &&
                        types.map((type) => (
                            <TableRow key={type.credit_package_id}>
                            <TableCell
                                className="tData"
                                style={{ textAlign: "center" }}
                            >
                                {type.credit_package_id}
                            </TableCell>
                            <TableCell
                                className="tData"
                                style={{ textAlign: "center" }}
                            >
                                {type.name}
                            </TableCell>
                            <TableCell
                                className="tData"
                                style={{ textAlign: "center" }}
                            >
                                {type.credits}
                            </TableCell>
                            <TableCell
                                className="tData"
                                style={{ textAlign: "center" }}
                            >
                                {type.discount_rate}%
                            </TableCell>
                            <TableCell
                                className="tData"
                                style={{ textAlign: "center" }}
                            >
                                <span
                                    dangerouslySetInnerHTML={{ __html: type.description }}
                                />
                            </TableCell>
                            <TableCell
                                className="tData"
                                style={{ textAlign: "center" }}
                            >
                                {type.status}
                            </TableCell>
                            <TableCell
                                className="tData"
                                style={{ textAlign: "center" }}
                            >
                                {new Date(
                                this.convertTimeLevel(type.start_date)
                                ).toLocaleDateString("en-US", {
                                year: "numeric",
                                month: "numeric",
                                day: "numeric",
                                })}
                            </TableCell>

                            <TableCell
                                className="tData"
                                style={{ textAlign: "center" }}
                            >
                                {new Date(
                                this.convertTimeLevel(type.end_date)
                                ).toLocaleDateString("en-US", {
                                year: "numeric",
                                month: "numeric",
                                day: "numeric",
                                })}
                            </TableCell>
                            <TableCell className="tData" style={{ textAlign: "center" }}>
                                {type.credits_expiry_type === 'days' ? (
                                    // Show days count if expiry type is days
                                    `after ${type.credits_expiry_duration} days of purcahse`
                                ) :  (
                                    // Show formatted date if expiry type is date
                                    new Date(this.convertTimeLevel(type.credits_expiry_duration
                                    )).toLocaleDateString("en-US", {
                                        year: "numeric",
                                        month: "numeric",
                                        day: "numeric",
                                    })
                                )}
</TableCell>
                                <TableCell
                                className="tData"
                                style={{ textAlign: "center" }}
                                >
                                <div className="btn-group">
                                    <Button
                                        className="btn btn-icon btn-primary btn-sm m-1 edit-assement-btn flaticon-edit-icon"
                                        title="Edit Details"
                                        onClick={() =>
                                        this.toggleUpdateTypeModal(type)
                                        }
                                    />
                                    {/* <Button
                                        className="btn btn-icon btn-danger btn-sm m-1 flaticon-delete"
                                        title="Delete Details"
                                        onClick={() =>
                                        this.deleteType(type.credit_package_id)
                                        }
                                    /> */}
                                </div>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                    </Table>
                </div>
                )}
            </CardBody>
            </Card>

        <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={this.state.showInsertModal}
            onHide={this.toggleAddPackagelModal}
        >
            <Modal.Header closeButton>
                <Modal.Title>Add new assessment credit package</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Row className="my-5">
                        <Form.Group
                            as={Col}
                            md="6"
                            controlId="exampleForm.ControlInput2"
                        >
                            <Form.Label>Name*</Form.Label>
                            <Form.Control
                                type="text"
                                name="name"
                                defaultValue={name}
                                placeholder="Name"
                                onChange={this.handleChange}
                            />
                            <div style={{ color: "red" }}>
                                {this.validator.message("name", name, "required")}
                            </div>
                        </Form.Group>
                        <Form.Group
                            as={Col}
                            md="6"
                            controlId="exampleForm.ControlInput2"
                        >
                            <Form.Label>Credits*</Form.Label>
                            <Form.Control
                                type="number"
                                name="credits"
                                min="0"
                                value={credits}
                                placeholder="Credits"
                                onChange={this.handleChange}
                            />
                            <div style={{ color: "red" }}>
                                {this.state.creditsError && <p>{this.state.creditsError}</p>}
                                {this.validator.message("credits", credits, [
                                    "required",
                                    "isFloat",
                                    "min:0"
                                ])}
                            </div>
                        </Form.Group>
                    </Row>

                    <Row className="my-5">
                        <Form.Group
                            as={Col}
                            md="6"
                            controlId="exampleForm.ControlInput2"
                        >
                            <Form.Label>Discount Rate*</Form.Label>
                            <Form.Control
                                type="text"
                                name="discount_rate"
                                defaultValue={discount_rate}
                                placeholder="Discount Rate"
                                onChange={this.handleChange}
                            />
                            <div style={{ color: "red" }}>
                                {this.state.discountRateError && <p>{this.state.discountRateError}</p>}
                                {this.validator.message("discount_rate", discount_rate, [
                                    "required",
                                    "isDecimal",
                                    "min:0",
                                    "max:100"
                                ])}
                            </div>
                        </Form.Group>
                        <Form.Group 
                            as={Col}
                            md="6"
                            controlId="formCreditsType">
                            {/* Radio Buttons for Credits Type */}
                            <Form.Label>Credits Type*</Form.Label>
                            <div>
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="Regular Credits"
                                    value="regular"
                                    name="creditsType"
                                    onChange={this.handleRadioChangeAdd}
                                    checked={this.state.packageType === 'regular'}
                                    className="form-check-inline"
                                />
                                <Form.Check
                                    inline 
                                    type="radio"
                                    label="Free Credits"
                                    value="free"
                                    name="creditsType"
                                    onChange={this.handleRadioChangeAdd}
                                    checked={this.state.packageType === 'free'}
                                    className="form-check-inline"
                                />
                            </div>
                        </Form.Group>
                    </Row>

                    {/* Minimum Package Amount for Regular Credits */}
                    {this.state.packageType === 'regular' && (
                        <Row className="my-5">
                            <Col md={7}>
                                <Form.Group md="12" controlId="exampleForm.ControlInput1">
                                    <Form.Label>Minimum Package Amount*</Form.Label>
                                    <div style={{ display: 'flex', gap: '0px', alignItems: 'center' }}>
                                        <Form.Select
                                            id="currency_types"
                                            name="currency_type_id"
                                            value={this.state.currency_type_id || ''}
                                            onChange={this.handleChange}
                                            className="form-control"
                                            style={{
                                                borderTopRightRadius: 0,
                                                borderBottomRightRadius: 0,
                                                width: '25%',
                                            }}
                                        >
                                            <option value="">Select</option>
                                            {this.state.allCurrencyTypes && this.state.allCurrencyTypes.map((option) => (
                                                <option key={option.currency_type_id} value={option.currency_type_id}>
                                                    {option.name}
                                                </option>
                                            ))}
                                        </Form.Select>

                                        <Form.Control
                                            type="number"
                                            name="minimum_package_amount"
                                            min="0"
                                            value={this.state.minimum_package_amount || ''}
                                            placeholder="Minimum Package Amount"
                                            onChange={this.handleChange}
                                            style={{
                                                borderTopLeftRadius: 0,
                                                borderBottomLeftRadius: 0,
                                                width: '75%',
                                            }}
                                        />
                                    </div>
                                    <div style={{ color: "red", marginTop: '4px' }}>
                                        {this.validator.message("currency_type_id", this.state.currency_type_id, "required")}
                                        {this.validator.message("minimum_package_amount", this.state.minimum_package_amount, ["required", "numeric", "min:0"])}
                                    </div>
                                </Form.Group>
                            </Col>
                        </Row>
                    )}

                    <Row className="my-5">
                        <Form.Group as={Col} md="12" controlId="formDescription">
                            {/* Description Input - Full Width */}
                            <Form.Label>Description*</Form.Label>
                            <ReactQuill
                                theme="snow"
                                value={description}
                                onChange={(value) => this.setState({ description: value })}
                                readOnly={isFreeCredits}
                                placeholder="Description"
                                modules={{
                                    toolbar: [
                                    [{ header: [1, 2, 3, false] }],      
                                    ['bold', 'italic', 'underline', 'strike', 'blockquote'], 
                                    [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }], 
                                    [{ size: ['small', false, 'large', 'huge'] }],  
                                    [{ color: [] }, { background: [] }],  
                                    [{ font: [] }],                        
                                    ['link', 'image'],                    
                                    ['clean'],                             
                                    ],
                                }}
                                formats={[
                                    'header',
                                    'bold', 'italic', 'underline', 'strike', 'blockquote',
                                    'list', 'bullet', 'indent',
                                    'size', 'color', 'background', 'font',
                                    'link', 'image',
                                ]}
                                />



                            <div style={{ color: "red" }}>
                                {this.validator.message(
                                    "description",
                                    description,
                                    "required|min:1|max:256"
                                )}
                            </div>
                        </Form.Group>
                    </Row>

                    <Row className="my-5">
                        <Form.Group
                            as={Col}
                            md="6"
                            controlId="exampleForm.ControlInput1"
                        >
                            <Form.Label>Status*</Form.Label>
                            <Form.Select
                                aria-label="Default select example"
                                name="status"
                                onChange={this.handleChange}
                                value={status}
                            >
                                <option value="">Select</option>
                                {statuses.map((singleStatus) => (
                                    <option key={singleStatus.id} value={singleStatus.name}>
                                        {singleStatus.name}
                                    </option>
                                ))}
                            </Form.Select>
                            <div style={{ color: "red" }}>
                                {this.validator.message("status", status, "required")}
                            </div>
                        </Form.Group>
                        <Form.Group
                            as={Col}
                            md="6"
                            controlId="exampleForm.ControlInput1"
                        >
                            <Form.Label>Start Date*</Form.Label>
                            <Form.Control
                                type="date"
                                name="start_date"
                                defaultValue={start_date}
                                placeholder="start date"
                                onChange={this.handleChange}
                            />
                            <div style={{ color: "red" }}>
                                {this.validator.message(
                                    "start_date",
                                    start_date,
                                    "required"
                                )}
                            </div>
                        </Form.Group>
                    </Row>

                    <Row className="my-5">
                        <Form.Group as={Col} md="6" controlId="noEndDate">
                            <Form.Label>Do you want to have an end date?</Form.Label>
                            <CheckBoxInline style={{ alignItems: "center" }}>
                                <Form.Label
                                    className="mb-0 mr-1"
                                    style={{ fontWeight: "500" }}
                                >
                                    Yes
                                </Form.Label>
                                <CheckBox
                                    onChange={(e) => {
                                        this.noEndDateSelected(e, true);
                                    }}
                                    checked={noEndDate}
                                />
                                <Form.Label
                                    className="mb-0 mr-1"
                                    style={{ fontWeight: "500" }}
                                >
                                    No
                                </Form.Label>
                                <CheckBox
                                    onChange={(e) => {
                                        this.noEndDateSelected(e, false);
                                    }}
                                    checked={!noEndDate}
                                />
                            </CheckBoxInline>
                        </Form.Group>

                        {noEndDate && (
                            <Form.Group
                                as={Col}
                                md="6"
                                controlId="exampleForm.ControlInput1"
                            >
                                <Form.Label>End Date*</Form.Label>
                                <Form.Control
                                    type="date"
                                    name="end_date"
                                    min={start_date}
                                    defaultValue={end_date}
                                    placeholder="end date"
                                    onChange={this.handleChange}
                                />
                                <div style={{ color: "red" }}>
                                    {this.validator.message(
                                        "end_date",
                                        end_date && noEndDate,
                                        "required"
                                    )}
                                </div>
                            </Form.Group>
                        )}
                    </Row>

                    {/* New Credit Expiry Section */}
                    <Row className="my-5">
                        <Form.Group as={Col} md="12" controlId="creditExpiryType">
                            <Form.Label>Credit Expiry After Purchase*</Form.Label>
                            <div className="mb-3">
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="Expire after specific days"
                                    value="days"
                                    name="expiryType"
                                    onChange={this.handleExpiryTypeChange}
                                    checked={this.state.expiryType === 'days'}
                                    className="form-check-inline"
                                />
                                <Form.Check
                                    inline 
                                    type="radio"
                                    label="Expire on specific date"
                                    value="date"
                                    name="expiryType"
                                    onChange={this.handleExpiryTypeChange}
                                    checked={this.state.expiryType === 'date'}
                                    className="form-check-inline"
                                />
                            </div>
                            
                            {this.state.expiryType === 'days' && (
                                <Form.Group controlId="expiryDays">
                                    <Form.Label>Number of Days (1-730)*</Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="expiryDays"
                                        value={this.state.expiryDays}
                                        min="1"
                                        max="730"
                                        placeholder="Enter number of days"
                                        onChange={this.handleExpiryDaysChange}
                                    />
                                    <div style={{ color: "red" }}>
                                        {this.validator.message(
                                            "expiryDays",
                                            this.state.expiryDays,
                                            "required|numeric|min:1,num|max:730,num"
                                        )}
                                    </div>
                                </Form.Group>
                            )}
                            
                            {this.state.expiryType === 'date' && (
                                <Form.Group controlId="expiryDate">
                                    <Form.Label>Expiry Date (must be in future and after the package start date)*</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="expiryDate"
                                        min={this.state.start_date || new Date(Date.now() + 86400000).toISOString().split('T')[0]}
                                        value={this.state.expiryDate}
                                        onChange={this.handleExpiryDateChange}
                                    />
                                    <div style={{ color: "red" }}>
                                        {this.validator.message(
                                            "expiryDate",
                                            this.state.expiryDate,
                                            `required|dateAfter:${this.state.start_date ? 'start_date' : new Date().toISOString().split('T')[0]}`
                                        )}
                                    </div>
                                </Form.Group>
                            )}
                        </Form.Group>
                    </Row>

                    <Modal.Footer>
                        <Button
                            className="modal-btn"
                            id="modal-close-button"
                            style={closeBtnStyle}
                            onClick={this.toggleAddPackagelModal}
                        >
                            Close
                        </Button>
                        {editVisibility && (
                            <Button
                                className="modal-btn"
                                variant="primary"
                                style={addBtnStyle}
                                onClick={this.submitType}
                            >
                                Save changes
                            </Button>
                        )}
                    </Modal.Footer>
                </Form>
            </Modal.Body>
        </Modal> 

        <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={this.state.showModal}
            onHide={this.toggleUpdateTypeModal}
        >
            <Modal.Header closeButton>
                <Modal.Title>Update Assessment Credit Package</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Row className="my-5">
                        <Form.Group as={Col} md="6" controlId="exampleForm.ControlInput1">
                            <Form.Label>Name*</Form.Label>
                            <Form.Control
                                type="text"
                                name="name"
                                defaultValue={name}
                                placeholder="Name"
                                onChange={this.handleChange}
                            />
                            <div style={{ color: "red" }}>
                                {this.validator.message("name", name, "required")}
                            </div>
                        </Form.Group>
                        <Form.Group as={Col} md="6" controlId="exampleForm.ControlInput1">
                            <Form.Label>Credits*</Form.Label>
                            <Form.Control
                                type="text"
                                name="credits"
                                defaultValue={credits}
                                placeholder="Credits"
                                onChange={this.handleChange}
                                disabled
                            />
                            <div style={{ color: "red" }}>
                                {this.validator.message("credits", credits, [
                                    "required",
                                    "isFloat",
                                ])}
                            </div>
                        </Form.Group>
                    </Row>

                    <Row className="my-5">
                        <Form.Group as={Col} md="6" controlId="exampleForm.ControlInput1">
                            <Form.Label>Discount Rate*</Form.Label>
                            <Form.Control
                                type="text"
                                name="discount_rate"
                                defaultValue={discount_rate}
                                placeholder="Discount Rate"
                                onChange={this.handleChange}
                                disabled
                            />
                            <div style={{ color: "red" }}>
                                {this.validator.message("discount_rate", discount_rate, [
                                    "required",
                                    "isDecimal",
                                ])}
                            </div>
                        </Form.Group>
                        <Form.Group as={Col} md="6" controlId="formCreditsTypeEdit">
                            <Form.Label>Credits Type*</Form.Label>
                            <div>
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="Regular Credits"
                                    value="regular"
                                    name="creditsType"
                                    onChange={this.handleRadioChangeUpdate}
                                    checked={this.state.packageType === 'regular'}
                                    className="form-check-inline"
                                    disabled
                                />
                                <Form.Check
                                    inline 
                                    type="radio"
                                    label="Free Credits"
                                    value="free"
                                    name="creditsType"
                                    onChange={this.handleRadioChangeUpdate}
                                    checked={this.state.packageType === 'free'}
                                    className="form-check-inline"
                                    disabled
                                />
                            </div>
                        </Form.Group>
                    </Row>

                    {/* Minimum Package Amount for Regular Credits - Edit Form */}
                    {this.state.packageType === 'regular' && (
                        <Row className="my-5">
                            <Col md={7}>
                                <Form.Group md="12" controlId="exampleForm.ControlInput1">
                                    <Form.Label>Minimum Package Amount*</Form.Label>
                                    <div style={{ display: 'flex', gap: '0px', alignItems: 'center' }}>
                                        <Form.Select
                                            id="currency_types_edit"
                                            name="currency_type_id"
                                            value={this.state.currency_type_id || ''}
                                            onChange={this.handleChange}
                                            className="form-control"
                                            style={{
                                                borderTopRightRadius: 0,
                                                borderBottomRightRadius: 0,
                                                width: '25%',
                                            }}
                                        >
                                            <option value="">Select</option>
                                            {this.state.allCurrencyTypes && this.state.allCurrencyTypes.map((option) => (
                                                <option key={option.currency_type_id} value={option.currency_type_id}>
                                                    {option.name}
                                                </option>
                                            ))}
                                        </Form.Select>

                                        <Form.Control
                                            type="number"
                                            name="minimum_package_amount"
                                            min="0"
                                            value={this.state.minimum_package_amount || ''}
                                            placeholder="Minimum Package Amount"
                                            onChange={this.handleChange}
                                            style={{
                                                borderTopLeftRadius: 0,
                                                borderBottomLeftRadius: 0,
                                                width: '75%',
                                            }}
                                        />
                                    </div>
                                    <div style={{ color: "red", marginTop: '4px' }}>
                                        {this.validator.message("currency_type_id", this.state.currency_type_id, "required")}
                                        {this.validator.message("minimum_package_amount", this.state.minimum_package_amount, ["required", "numeric", "min:0"])}
                                    </div>
                                </Form.Group>
                            </Col>
                        </Row>
                    )}

                    <Row className="my-5">
                        <Form.Group as={Col} md="12" controlId="formDescriptionEdit">
                            <Form.Label>Description*</Form.Label>
                            <ReactQuill
                                theme="snow"
                                value={description}
                                onChange={(value) => this.setState({ description: value })}
                                readOnly={isFreeCredits}
                                placeholder="Description"
                                modules={{
                                    toolbar: [
                                    [{ header: [1, 2, 3, false] }],      
                                    ['bold', 'italic', 'underline', 'strike', 'blockquote'], 
                                    [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }], 
                                    [{ size: ['small', false, 'large', 'huge'] }],  
                                    [{ color: [] }, { background: [] }],  
                                    [{ font: [] }],                        
                                    ['link', 'image'],                    
                                    ['clean'],                             
                                    ],
                                }}
                                formats={[
                                    'header',
                                    'bold', 'italic', 'underline', 'strike', 'blockquote',
                                    'list', 'bullet', 'indent',
                                    'size', 'color', 'background', 'font',
                                    'link', 'image',
                                ]}
                                />

                            
                            <div style={{ color: "red" }}>
                                {this.validator.message(
                                    "description",
                                    description,
                                    "required|min:1|max:256"
                                )}
                            </div>
                        </Form.Group>
                    </Row>

                    <Row className="my-5">
                        <Form.Group as={Col} md="6" controlId="exampleForm.ControlInput1">
                            <Form.Label>Status*</Form.Label>
                            <Form.Select
                                aria-label="Default select example"
                                name="status"
                                onChange={this.handleChange}
                                value={status}
                            >
                                <option value="">Select</option>
                                {statuses.map((singleStatus) => (
                                    <option key={singleStatus.id} value={singleStatus.name}>
                                        {singleStatus.name}
                                    </option>
                                ))}
                            </Form.Select>
                            <div style={{ color: "red" }}>
                                {this.validator.message("status", status, "required")}
                            </div>
                        </Form.Group>
                        <Form.Group as={Col} md="6" controlId="exampleForm.ControlInput1">
                            <Form.Label>Start Date*</Form.Label>
                            <Form.Control
                                type="date"
                                name="start_date"
                                min={new Date().toISOString().split('T')[0]}
                                value={start_date ? this.formatDateForInput(new Date(start_date)) : ""}
                                placeholder="start date"
                                onChange={this.handleChange}
                            />
                            <div style={{ color: "red" }}>
                                {this.validator.message("start_date", start_date, "required")}
                            </div>
                        </Form.Group>
                    </Row>

                    <Row className="my-5">
                        <Form.Group as={Col} md="6" controlId="noEndDate">
                            <Form.Label>Do you want to have an end date?</Form.Label>
                            <CheckBoxInline style={{ alignItems: "center" }}>
                                <Form.Label className="mb-0 mr-1" style={{ fontWeight: "500" }}>
                                    Yes
                                </Form.Label>
                                <CheckBox
                                    onChange={(e) => this.noEndDateSelected(e, true)}
                                    checked={noEndDate}
                                />
                                <Form.Label className="mb-0 mr-1" style={{ fontWeight: "500" }}>
                                    No
                                </Form.Label>
                                <CheckBox
                                    onChange={(e) => this.noEndDateSelected(e, false)}
                                    checked={!noEndDate}
                                />
                            </CheckBoxInline>
                        </Form.Group>

                        {noEndDate && (
                            <Form.Group as={Col} md="6" controlId="endDate">
                                <Form.Label>End Date*</Form.Label>
                                <Form.Control
                                    type="date"
                                    name="end_date"
                                    min={start_date}
                                    value={end_date ? this.formatDateForInput(new Date(end_date)) : ""}
                                    placeholder="end date"
                                    onChange={this.handleChange}
                                />
                                <div style={{ color: "red" }}>
                                    {this.validator.message("end_date", end_date && noEndDate, "required")}
                                </div>
                            </Form.Group>
                        )}
                    </Row>

                    {/* Credit Expiry Section */}
                    <Row className="my-5">
                        <Form.Group as={Col} md="12" controlId="creditExpiryType">
                            <Form.Label>Credit Expiry After Purchase*</Form.Label>
                            <div className="mb-3">
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="Expire after specific days"
                                    value="days"
                                    name="expiryType"
                                    onChange={this.handleExpiryTypeChange}
                                    checked={this.state.expiryType === 'days'}
                                    className="form-check-inline"
                                />
                                <Form.Check
                                    inline 
                                    type="radio"
                                    label="Expire on specific date"
                                    value="date"
                                    name="expiryType"
                                    onChange={this.handleExpiryTypeChange}
                                    checked={this.state.expiryType === 'date'}
                                    className="form-check-inline"
                                />
                            </div>
                            
                            {this.state.expiryType === 'days' && (
                                <Form.Group controlId="expiryDays">
                                    <Form.Label>Number of Days (1-730)*</Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="expiryDays"
                                        value={this.state.expiryDays || ''}
                                        min="1"
                                        max="730"
                                        placeholder="Enter number of days"
                                        onChange={this.handleExpiryDaysChange}
                                    />
                                    <div style={{ color: "red" }}>
                                        {this.validator.message(
                                            "expiryDays",
                                            this.state.expiryDays,
                                            "required|numeric|min:1,num|max:730,num"
                                        )}
                                    </div>
                                </Form.Group>
                            )}
                            
                            {this.state.expiryType === 'date' && (
                                <Form.Group controlId="expiryDate">
                                    <Form.Label>Expiry Date (must be in future and after start date)*</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="expiryDate"
                                        min={this.state.start_date || new Date(Date.now() + 86400000).toISOString().split('T')[0]}
                                        value={this.state.expiryDate || ''}
                                        onChange={this.handleExpiryDateChange}
                                    />
                                    <div style={{ color: "red" }}>
                                        {this.validator.message(
                                            "expiryDate",
                                            this.state.expiryDate,
                                            `required|dateAfter:${this.state.start_date || new Date().toISOString().split('T')[0]}`
                                        )}
                                    </div>
                                </Form.Group>
                            )}
                        </Form.Group>
                    </Row>

                    <Modal.Footer>
                        <Button
                            className="modal-btn"
                            id="modal-close-button"
                            style={closeBtnStyle}
                            onClick={this.toggleUpdateTypeModal}
                        >
                            Close
                        </Button>
                        {editVisibility && (
                            <Button
                                className="modal-btn"
                                variant="primary"
                                style={addBtnStyle}
                                onClick={this.updateType}
                            >
                                Save changes
                            </Button>
                        )}
                    </Modal.Footer>
                </Form>
            </Modal.Body>
        </Modal>
        </>
        );
    }
    }
